// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
export enum DataSourceType {
  Local,
  Firebase,
  Swagger
}

export const environment = {
  production: true,
  agm: { apiKey: 'AIzaSyBvkVTU8V6SmCgqNpXHpVMJt4Tcz_l_fW8' },
  firebase: {
    apiKey: 'AIzaSyBvkVTU8V6SmCgqNpXHpVMJt4Tcz_l_fW8',
    authDomain: 'ioccatsdemo.firebaseapp.com',
    databaseURL: 'https://ioccatsdemo.firebaseio.com',
    projectId: 'ioccatsdemo',
    storageBucket: 'ioccatsdemo.appspot.com',
    messagingSenderId: '652898326248'
  },
  apiRootLocal: 'assets/data',
  apiRootIocCATS: 'https://api.iocontrols.com',
  reportFallbackMonths: 6,
  delayEmulatorTimer: 2000,
  dataSource: DataSourceType.Swagger,
  ssoUrl: 'https://sso.iocontrols.com',
  iotpProfileUrl: 'https://iotp.iocontrols.com/profile',
  iotpDeviceUrl: 'https://iotp.iocontrols.com/iotp/device'
};
